
riot.tag2('popups', '  <div class="popups popups-top-left" name="tl" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-top-right" name="tr" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-bottom-right" name="br" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-bottom-left" name="bl" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n', 'popups .popups,[riot-tag="popups"] .popups,[data-is="popups"] .popups{ position: fixed; width: 250px; z-index: 9999; -webkit-hyphens: auto; -moz-hyphens: auto; -ms-hyphens: auto; hyphens: auto; word-wrap: break-word; } popups .popups-top-left,[riot-tag="popups"] .popups-top-left,[data-is="popups"] .popups-top-left{ top: 0; left: 0; } popups .popups-top-right,[riot-tag="popups"] .popups-top-right,[data-is="popups"] .popups-top-right{ top: 0; right: 0; } popups .popups-bottom-left,[riot-tag="popups"] .popups-bottom-left,[data-is="popups"] .popups-bottom-left{ bottom: 0; left: 0; } popups .popups-bottom-right,[riot-tag="popups"] .popups-bottom-right,[data-is="popups"] .popups-bottom-right{ bottom: 0; right: 0; }', '', function(opts) {
'use strict';

var self = this;

self.create = function (params) {
    if (!params) return;

    var popup = document.createElement('bs-popup');
    var position = params.position || opts.position || undefined,
        animation = params.animation || opts.animation || undefined,
        timeout = 5000;

    if (opts.timeout !== undefined && typeof parseInt(opts.timeout) === 'number') {
        timeout = parseInt(opts.timeout);
    }
    if (params.timeout !== undefined && typeof parseInt(params.timeout) === 'number') {
        timeout = parseInt(params.timeout);
    }

    if (position && typeof position === 'string') {
        if (position === 'top-left') self.tl.insertBefore(popup, null);
        if (position === 'top-right') self.tr.insertBefore(popup, null);
        if (position === 'bottom-right') self.br.insertBefore(popup, self.br.children[0]);
        if (position === 'bottom-left') {
            self.bl.insertBefore(popup, self.bl.children[0]);
        }
    } else {
        self.tr.insertBefore(popup, null);
    }

    popup = riot.mount(popup, 'bs-popup', {
        title: params.title,
        text: params.text,
        style: params.style || 'popup-primary',
        animation: animation,
        position: position || 'top-right'
    })[0];

    if (timeout != 0) {
        popup.timer = setTimeout(function () {
            popup.close();
        }, timeout + 300);
    }
};
});
riot.tag2('bs-popup', '  <div class="popup {opts.style} {css}" onclick="{close}">\n    <div class="h4" if="{opts.title}">{opts.title}</div>\n    <p if="{opts.text}">{opts.text}</p>\n  </div>\n', 'bs-popup .popup,[riot-tag="bs-popup"] .popup,[data-is="bs-popup"] .popup{ background-color: rgba(60, 60, 60, 0.95); padding: 6px; color: #fff; margin: 5px; z-index: 9999; border-radius: 5px; -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5); box-shadow: 0 3px 9px rgba(0, 0, 0, .5); -webkit-animation-duration: 0.3s; animation-duration: 0.3s; } bs-popup .popup-default,[riot-tag="bs-popup"] .popup-default,[data-is="bs-popup"] .popup-default{ background-color: rgba(255, 255, 255, 0.95); color: #333; border-color: #ccc; } bs-popup .popup-primary,[riot-tag="bs-popup"] .popup-primary,[data-is="bs-popup"] .popup-primary{ background-color: rgba(51, 122, 183, 0.95); color: #fff; border-color: #2e6da4; } bs-popup .popup-success,[riot-tag="bs-popup"] .popup-success,[data-is="bs-popup"] .popup-success{ background-color: rgba(92, 184, 92, 0.95); color: #fff; border-color: #4cae4c; } bs-popup .popup-info,[riot-tag="bs-popup"] .popup-info,[data-is="bs-popup"] .popup-info{ background-color: rgba(91, 192, 222, 0.95); color: #fff; border-color: #46b8da; } bs-popup .popup-warning,[riot-tag="bs-popup"] .popup-warning,[data-is="bs-popup"] .popup-warning{ background-color: rgba(240, 173, 78, 0.95); color: #fff; border-color: #eea236; } bs-popup .popup-danger,[riot-tag="bs-popup"] .popup-danger,[data-is="bs-popup"] .popup-danger{ background-color: rgba(217, 83, 79, 0.95); color: #fff; border-color: #d43f3a; } bs-popup .popup p,[riot-tag="bs-popup"] .popup p,[data-is="bs-popup"] .popup p{ margin: 0px; } bs-popup .popup .h4,[riot-tag="bs-popup"] .popup .h4,[data-is="bs-popup"] .popup .h4,bs-popup .popup .h5,[riot-tag="bs-popup"] .popup .h5,[data-is="bs-popup"] .popup .h5,bs-popup .popup .h6,[riot-tag="bs-popup"] .popup .h6,[data-is="bs-popup"] .popup .h6,bs-popup .popup h4,[riot-tag="bs-popup"] .popup h4,[data-is="bs-popup"] .popup h4,bs-popup .popup h5,[riot-tag="bs-popup"] .popup h5,[data-is="bs-popup"] .popup h5,bs-popup .popup h6,[riot-tag="bs-popup"] .popup h6,[data-is="bs-popup"] .popup h6{ margin-top: 0; }', '', function(opts) {
    var self = this,
        animations = ['bounce', 'slide', 'fade', 'zoom'],
        isAnimation = animations.indexOf(opts.animation) > -1,
        direction = opts.position.indexOf('right') > -1 ? 'Right' : 'Left',
        css = {
            show: (isAnimation ? opts.animation + 'In' + direction + ' animated': ''),
            hide: (isAnimation ? opts.animation + 'Out' + direction + ' animated': '')
        }

    self.css = css.show

    self.close = function () {
        if (self.timer)
            clearTimeout(self.timer)

        if (isAnimation) {
            self.css = css.hide
            self.update()
            setTimeout(function () {
                self.unmount()
            }, 300)
        } else {
            self.unmount()
        }
    }
});


// WEBPACK FOOTER //
// ./components/popups.tag